import { Button, Form, InputNumber, Select, Space } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import SelectDropdownLgIcon from "../../../assets/icons/SelectDropdownLgIcon";
import { useUpdateLeaveProrateMutation } from "../../../features/leaveProrate/leaveProrateApi";
import { useGetLeaveTypeListQuery } from "../../../features/leaveType/leaveTypeApi";
import useError from "../../../hooks/useError";
import { toast } from "../../../lib/toast";
import {
  GetLeaveProrateDetailsType,
  ModalComponentProps,
} from "../../../types";
import { selectArrayOption, selectSearchOption } from "../../../utils/utils";
import EmployeeInfoItem from "../../common/EmployeeInfoItem";
import CustomModal from "../../ui/CustomModal";

export default function UpdateLeaveTypeModal({
  handleClose,
  type,
  data,
  ...rest
}: ModalComponentProps<
  GetLeaveProrateDetailsType["data"]["business_member_leave_type"]
>) {
  const [form] = Form.useForm();
  const { detailsId } = useParams();
  const {
    data: leaveTypeListData,
    isLoading: isLeaveTypeListLoading,
    isError: isLeaveTypeError,
    error: leaveTypeError,
  } = useGetLeaveTypeListQuery({});
  const [updateLeaveProrate, { isError, error, isLoading, isSuccess }] =
    useUpdateLeaveProrateMutation();
  useError(isLeaveTypeError, leaveTypeError, "Get leave Type fail");
  useError(isError, error, "Leave prorate update fail");

  const onFinish = (values: any) => {
    if (detailsId)
      updateLeaveProrate({
        id: detailsId,
        body: values,
      });
  };

  useEffect(() => {
    if (Object.keys(data || {}) && type === "UPDATE") {
      form.setFieldsValue({
        leave_type_id: data?.leave_type?.id,
        total_days: data?.total_days,
        note: data?.note,
      });
    }
  }, [form, data, type]);

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "Leave prorate has been updated successfully");
      return handleClose();
    }
  }, [handleClose, isSuccess]);

  return (
    <CustomModal
      title={"Update"}
      {...rest}
      handleClose={handleClose}
      width={460}
      footer={null}
    >
      <EmployeeInfoItem
        img={data?.employee_info?.pro_pic}
        name={data?.employee_info?.name}
        id={data?.employee_info?.employee_id}
        designation={data?.employee_info?.designation}
        department={data?.employee_info?.department}
        email={data?.employee_info?.email}
      />

      <Form
        className="custom-form mt-4"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <Form.Item
          name="leave_type_id"
          label="Leave Type"
          className="mb-4"
          rules={[
            {
              required: true,
              message: "Please enter leave type",
            },
          ]}
        >
          <Select
            placeholder="Select"
            size="large"
            allowClear
            showSearch
            filterOption={selectSearchOption}
            options={
              selectArrayOption(
                leaveTypeListData?.data?.leave_types,
                "title",
                "id"
              ) || []
            }
            suffixIcon={<SelectDropdownLgIcon />}
            loading={isLeaveTypeListLoading}
          />
        </Form.Item>
        <Form.Item
          name="total_days"
          label="Leave Count"
          className="mb-4"
          rules={[
            {
              required: true,
              message: "Please enter leave count",
            },
          ]}
        >
          <InputNumber placeholder="Ex: 4" style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          name="note"
          label="Remarks"
          className="mb-4"
          rules={[
            {
              required: true,
              message: "Please enter remarks",
            },
          ]}
        >
          <TextArea placeholder="Type..." rows={4} />
        </Form.Item>

        <Space className="w-full mt-2" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isLoading}
          >
            Update
          </Button>
        </Space>
      </Form>
    </CustomModal>
  );
}
